import { observer } from 'mobx-react';
import { Link } from '../../../../../../../Resource/Types';
import Modal from '../../../../../../Modal';
import DownloadModel from '../DownloadModel';
import Header from '../InviteModal/Header';
import InviteModalBody from '../InviteModal/InviteModalBody';
import SelectDateModalBody from '../SelectDateModal';
import InviteParticipantStore from '../Store';
import ParticipantsInvitedModal from './ParticipantsInvitedModal';
import ReadyModalContent from '../SelectParticipantsModal/ReadyModalContent';
import LoadingModal from '../SelectParticipantsModal/ReadyModalContent/LoadingModal';

interface Props {
  store: InviteParticipantStore;
  links: ReadonlyArray<Link>;
}

export interface InviteParticipantStoreActions {
  submit: () => void;
  setDate: (date: string) => void;
  setTime: (date: string) => void;
  setTimezone: (timezone: string) => void;
  setSkipCommunications: (skipCommunications: boolean) => void;
  back: () => void;
}

export const resetModal = (store: InviteParticipantStore) => {
  store.modalStore.close();
  store.waiting();
};

function RenderInviteParticipantsModal({ store, links }: Props) {
  switch (store.modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      switch (store.state.kind) {
        case 'waiting':
          return <></>;
        case 'get-license-information':
          return <LoadingModal close={store.modalStore.close} />;
        case 'ready':
        case 'new-participant':
        case 'new-group':
        case 'remove-participant':
        case 'remove-group':
        case 'error':
          return <ReadyModalContent store={store} links={links} state={store.state} />;
        case 'participants-invited':
          return <ParticipantsInvitedModal store={store} state={store.state} />;
        case 'submitting':
        case 'inviting':
          const actions: InviteParticipantStoreActions = {
            submit: store.submit,
            setDate: store.setDate,
            setTime: store.setTime,
            setTimezone: store.setTimezone,
            setSkipCommunications: store.setSkipCommunications,
            back: store.back,
          };
          return (
            <Modal
              title={<Header />}
              close={() => resetModal(store)}
              customBackgroundCssClasses="bg-teal-100 opacity-60"
              modalWidth="w-2/5"
            >
              <InviteModalBody state={store.state} actions={actions} />
            </Modal>
          );
        case 'selecting-date':
          return (
            <Modal
              close={() => resetModal(store)}
              title={<Header />}
              customBackgroundCssClasses="bg-teal-100 opacity-60"
              modalWidth="w-2/5"
            >
              <SelectDateModalBody
                state={store.state}
                actions={{
                  inviting: store.inviting,
                  selectDate: store.selectDate,
                  back: store.back,
                }}
              />
            </Modal>
          );
        case 'download-program':
          return <DownloadModel store={store} link={store.state.link} state={store.state} />;
      }
  }
}

export default observer(RenderInviteParticipantsModal);
